import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AddPlaceToGroupUseCaseInterface } from 'domain/usecases';

export class RemoteAddPlaceToGroup implements AddPlaceToGroupUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<AddPlaceToGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: AddPlaceToGroupUseCaseInterface.Params,
  ): Promise<AddPlaceToGroupUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: `${this.url}`,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
